import Hearing from "@mui/icons-material/Hearing";
import Inbox from "@mui/icons-material/Inbox";
import Language from "@mui/icons-material/Language";
import PermMedia from "@mui/icons-material/PermMedia";
import PieChartOutlineRounded from "@mui/icons-material/PieChartOutlineRounded";
import Send from "@mui/icons-material/Send";
import Timeline from "@mui/icons-material/Timeline";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { usePermissions } from "../../../../../server/auth/use-permissions";
import { useFlag } from "../../../../../server/optimizely";
import { useAccountLimitsContext } from "../../../../context/account-limit-context";
import { useAnalyticsPerms } from "../../../../employees/hooks/use-analytics";
import { useInboxCount } from "../hooks/use-inbox-count";
import { useIsActive } from "../hooks/use-is-active";
import { Item } from "../item";
import { Programs } from "../programs";
import { Section } from "../section";
import { NavbarBadge } from "./navbar-badge";

export const NavOptions: FC = () => {
  const { t } = useTranslation();

  const [inbox_menu_option] = useFlag("sms_menu_option");

  const isActive = useIsActive();
  const perms = usePermissions();

  const analyticsPerms = useAnalyticsPerms();
  const showRecipientActivityPage = perms.super_admin;

  const { listen_entitlement } = useAccountLimitsContext();

  const unread_conversation_count = useInboxCount();

  return (
    <Section>
      <>
        <Item
          data-analytics-id="sidebar-content-library"
          title={t("Content Library")}
          icon={<PermMedia />}
          onClick={{ type: "href", value: "/content-library" }}
          active={isActive("/content-library")}
        />
        <Item
          data-analytics-id="sidebar-discover"
          title={t("Discover")}
          icon={<Language />}
          onClick={{ type: "href", value: "/discover" }}
          active={isActive("/discover", true)}
        />
        <Item
          data-analytics-id="sidebar-listen"
          title={t("Listen")}
          icon={<Hearing />}
          onClick={{ type: "href", value: "/listen" }}
          active={isActive("/listen", true)}
          label={listen_entitlement === "Pro" ? null : <NavbarBadge badgeContent="New" />}
        />
        <Programs />
        <Item
          data-analytics-id="sidebar-send-communications"
          title={t("Sent Communications")}
          icon={<Send />}
          onClick={{ type: "href", value: "/moments/history" }}
          active={isActive("/moments/history")}
        />
        {analyticsPerms.length > 0 && (
          <Item
            data-analytics-id="sidebar-analytics"
            title={t("Analytics")}
            icon={<PieChartOutlineRounded />}
            onClick={{ type: "href", value: "/analytics" }}
            active={isActive("/analytics")}
            label={<NavbarBadge badgeContent="Beta" />}
          />
        )}

        {showRecipientActivityPage === true && (
          <Item
            data-analytics-id="sidebar-recipient-activity"
            title={t("Recipient Activity")}
            icon={<Timeline />}
            onClick={{ type: "href", value: "/recipient-activity" }}
            active={isActive("/recipient-activity", true)}
          />
        )}

        {inbox_menu_option && (
          <Item
            data-analytics-id="sidebar-inbox"
            title={t("Inbox")}
            icon={<Inbox />}
            onClick={{ type: "href", value: "/inbox" }}
            active={isActive("/inbox", true)}
            label={
              unread_conversation_count ? (
                <NavbarBadge color="primary" badgeContent={unread_conversation_count} />
              ) : null
            }
          />
        )}
      </>
    </Section>
  );
};
